import { useLoaderData } from 'react-router'

import { EmailProfilePrintLayout } from '../EmailProfilePrintLayout'

function EmailThreadProfilePrint() {
  const data = useLoaderData()

  return (
    <EmailProfilePrintLayout
      messages={data?.messages}
      requestNumber={data?.requestNumber}
      subject={data?.subject}
    />
  )
}

export default EmailThreadProfilePrint
